import { ProviderI, ProviderListI } from "interfaces";
import { get, patch, post, remove } from "services/services.methods";
import { ProviderPath } from "services/services.paths";

export const getProviders = async () => {
  const response = await get<ProviderListI[]>(ProviderPath.get);
  return response.data;
};

export const removeProvider = async (id: number) => {
  const response = await remove<any>(`${ProviderPath.delete}/${id}`);
  return response;
};

export const createProvider = async (provider: ProviderI) => {
  const response = await post<any>(ProviderPath.post, provider);
  return response;
};

export const updateProvider = async (providerId: number, provider: ProviderI) => {
  const response = await patch<any>(`${ProviderPath.put}/${providerId}`, provider);
  return response;
};
